module.exports = __webpack_public_path__ + "img/setUp.c8930e60.png";